import './index.css';
import nmcConfig from '../../config/config'

/**
 * 提示
 * @class tips
 * @static
*/
var tips = {
    enableLoading: 1,
    isLoading: 0,
    manualReqNum: 0,

    /**
     * 成功提示
     * @method success
     * @param  {String} str 提示内容
     * @param  {Int}    duration 持续时间
     * @author evanyuan
     */
    success: function (str, duration) {
        this.flash(str, 'success', duration)
    },

    /**
     * 失败或错误提示
     * @method error
     * @param  {String} str 提示内容
     * @param  {Int}    duration 持续时间
     * @author evanyuan
     */
    error: function (str, duration) {
        this.flash(str, 'error', duration)
    },

    /**
     * 操作中提示
     * @method error
     * @param  {String} str 提示内容
     * @param  {Int}    duration 持续时间
     * @author enofan
     */
    loading: function (str, duration) {
        this.flash(str, 'loading', duration)
    },

    /**
     * 小黄条提示
     * @method flash
     * @param  {String} str 提示内容
     * @param  {String} type 类型
     * @param  {Int}    duration 持续时间
     * @author evanyuan
     */
    flash: function (str, type, duration) {

    },

    /**
     * 显示小黄条
     * @method showFlash
     * @param  {String} str 提示内容
     * @param  {String} icoClass 图标class (top-alert-icon-waring top-alert-icon-done top-alert-icon-doing)
     * @author evanyuan
     */
    showFlash: function (str, icoClassName) {

    },

    //隐藏小黄条
    hideFlash: function (fromTiming) {

    },

    //立即隐藏小黄条
    hideFlashNow: function () {
        $('#flashMsg').hide().html('');
        $('#topAlert').hide();
    },

    /**
     * 初始化全局加载提示
     * @method initLoading
     * @author evanyuan
     */
    initLoading: function () {

    },

    _loadingStart: function (opt) {

    },

    _loadingStop: function () {

    },

    //显示loading
    showLoading: function (opt) {
        opt = opt || {};
        this.showFlash(opt.text || nmcConfig.loadingWord, opt.className || 'top-alert-icon-doing');
    },

    //停止加载状态
    stopLoading: function () {
        this.isLoading = 0;
        this.hideFlash();
    },

    //手动的请求计数, 用于接入业务jsonp方式等复用loading逻辑
    requestStart: function (opt) {

    },

    requestStop: function () {

    },

    //禁用启用加载提示
    setLoading: function (_bool) {
        this.enableLoading = _bool;
    }

};
export default tips;